import Vue from 'vue'
import Router from 'vue-router'
import home from '@/components/Listing'
import Header from '@/components/Header.vue'
import Requests from '@/components/dashboard/Requests.vue'
import Changelog from "@/components/utils/Changelog.vue"
import PaymentResult from '@/components/payments/PaymentResult.vue'
import store from '@/vuex/store'
import ValuationUusmaa from '@/components/pricing/ValuationUusmaa.vue'
import ValuationMoowle from '@/components/pricing/ValuationMoowle.vue'
import listingManager from '@/components/ListingManager.vue'
import Chat from '@/components/chat.vue'
import Components from '@/views/Components.vue'
import PropertyCalendar from '@/components/property-calendar/PropertyCalendar.vue'
import ApplicationRoutes from "./application/index";
import AddListingRoutes from "./listing/addListing/index";
import ListingRoutes from "./listing/index";
import BookingRoutes from "./booking/index";
import SettingsRoutes from "./settings/index";
import UserRoutes from "./user/index";
import ServiceRoutes from "./service/index"

import {getCurrentFirebaseUser} from '@/platform/auth/services/authService.js'

Vue.use(Router)

const commonRoutes = [
  {
    path: '/payments/callback',
    name: 'paymentCallback',
    components: {
      header: Header,
      content: PaymentResult
    },
    beforeEnter(to, from, next) {
      let user = getCurrentFirebaseUser()
      if (user && !user.isAnonymous) {
        next()
      } else {
        next('/login')
      }
    }
  },
  {
    path: '/dashboard',
    name: 'dashboard',
    components: {
      header: Header,
      content: home
    },
    props: {
      header: true,
      content: true
    },
    beforeEnter(to, from, next) {
      let user = getCurrentFirebaseUser()
      let userViewole = store.getters.userViewRole
      if (user && !user.isAnonymous) {
        if(userViewole === 'landlord') next()
        else next('/stays') 
      } else {
        next('/login')
      }
    }
  },
  {
    path: '/dashboard/requests',
    name: 'dashboardRequests',
    components: {
      header: Header,
      content: Requests
    },
    beforeEnter(to, from, next) {
      let user = getCurrentFirebaseUser()
      if (user && !user.isAnonymous) {
        next()
      } else {
        next('/login')
      }
    }
  },
  {
    path: '/chat',
    name: 'chat',
    components: {
      header: Header,
      content: Chat
    },
    props: {
      header: true,
      content: true
    },
    beforeEnter(to, from, next) {
      let user = getCurrentFirebaseUser()
      if (user && !user.isAnonymous) {
        next()
      } else {
        next('/login')
      }
    }
  },
  {
    path: '/manage',
    name: 'manage',
    components: {
      header: Header,
      content: listingManager
    },
    props: {
      header: true,
      content: true
    },
    beforeEnter(to, from, next) {
      let user = getCurrentFirebaseUser()
      if (user && !user.isAnonymous) {
        next()
      } else {
        next('/login')
      }
    }
  },
  {
    path: '/valuation',
    name: 'pricePrediction',
    components: {
      header: Header,
      content: ValuationMoowle
    },
    props: {
      header: true,
      content: true
    }
  },
  {
    path: '/uusmaa',
    name: 'uusmaa',
    components: {
      header: Header,
      content: ValuationUusmaa
    },
    props: {
      header: true,
      content: true
    }
  },
  {
    path: '/calendar',
    name: 'propertyCalendar',
    components: {
        header: Header,
        content: PropertyCalendar
    },
    props: {
        header: true,
        content: true
    },
    beforeEnter(to, from, next) {
      let user = getCurrentFirebaseUser();
      if (user && !user.isAnonymous) {
        next();
      } else {
        next('/login');
      }
    }
  },
  {
    path: '/changelog',
    name: 'changelog',
    components: {
        header: Header,
        content: Changelog
    },
    props: {
        header: true,
        content: true
    }
  },
  {
    path: '/components',
    name: 'components',
    components: {
        header: Header,
        content: Components
    },
    props: {
        header: true,
        content: true
    }
  },
]

export default new Router({
  mode: 'hash',
  routes: commonRoutes.concat(ApplicationRoutes, AddListingRoutes, ListingRoutes, BookingRoutes, SettingsRoutes, UserRoutes, ServiceRoutes)
})



// WEBPACK FOOTER //
// ./src/router/index.js